// extracted by mini-css-extract-plugin
export default {"melodyVideo":"WN-z","isFullWidth":"XN-z","landingPageVideo":"YN-z","play":"ZN-z","iframeVideo":"_N-z","playHidden":"aO-z","fullwidth":"bO-z"};